import { useState, useEffect } from 'react';
import { loadAsync } from 'expo-font';
import { logError } from '@/utils/logHandling';
import {
  AntDesign,
  Entypo,
  EvilIcons,
  Feather,
  FontAwesome,
  FontAwesome5,
  FontAwesome6,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  SimpleLineIcons,
} from '@expo/vector-icons';

import { Platform } from 'react-native';
import { IS_WEB } from '@/utils/platform';

const fonts = {
  ABeeZeeItalic:
    Platform.OS === 'web'
      ? { uri: '/fonts/ABeeZee/ABeeZee-Italic.ttf' }
      : require('../assets/fonts/ABeeZee/ABeeZee-Italic.ttf'),

  ABeeZeeRegular:
    Platform.OS === 'web'
      ? { uri: '/fonts/ABeeZee/ABeeZee-Regular.ttf' }
      : require('../assets/fonts/ABeeZee/ABeeZee-Regular.ttf'),

  Inter:
    Platform.OS === 'web'
      ? { uri: '/fonts/Inter/Inter_24pt-Regular.ttf' }
      : require('../assets/fonts/Inter/Inter_24pt-Regular.ttf'),
  InterSemiBold:
    Platform.OS === 'web'
      ? { uri: '/fonts/Inter/Inter_24pt-SemiBold.ttf' }
      : require('../assets/fonts/Inter/Inter_24pt-SemiBold.ttf'),

  // @expo/vector-icons fonts for offline support (web only)
  ...(IS_WEB
    ? [
        AntDesign,
        Entypo,
        EvilIcons,
        Feather,
        FontAwesome,
        FontAwesome5,
        FontAwesome6,
        Ionicons,
        MaterialCommunityIcons,
        MaterialIcons,
        SimpleLineIcons,
      ].reduce((acc, IconSet) => ({ ...acc, ...IconSet.font }), {})
    : {}),
};

export const useFont = () => {
  const [fontsReady, setFontsReady] = useState(false);

  useEffect(() => {
    async function loadFonts() {
      try {
        await loadAsync(fonts);
      } catch (error) {
        logError('Error loading font', error);
      }
      setFontsReady(true);
    }

    loadFonts();
  }, []);

  return fontsReady;
};
